/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EPlaceType {
  GeoFence = 0,
  HotSpot = 1,
  FuelSite = 2
}
